import { Form, Input } from 'antd';
import { useEffect, useState } from 'react';
import CustomModal from '../CustomModal';
import { Users } from 'lucide-react';
import { createGroup, updateGroup } from '../../redux/actions/groups';

const CreateGroup = ({ open, onCancel, data, onNewGroupCreated }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const handleFinish = async (values) => {
        setLoading(true);
        const res = data
            ? await updateGroup(data.id, values)
            : await createGroup(values);


        if (res?.ack) {
            if (!data && res?.data) onNewGroupCreated(res.data);
            onCancel();
        }
        setLoading(false);
    };

    useEffect(() => {
        if (data) {
            form.setFieldsValue({
                name: data?.name,
            });
        } else {
            form.resetFields();
        }
    }, [data, form]);

    return (
        <CustomModal
            title={data ? "Update Group" : "Create Group"}
            open={open}
            onCancel={onCancel}
            okText={data ? "Update" : "Create"}
            onOk={() => form.submit()}
            okButtonProps={{ loading }}
        >
            <Form form={form} layout="vertical" size='large' onFinish={handleFinish}>
                <Form.Item
                    name="name"
                    label="Group Name"
                    rules={[{ required: true, message: 'Please enter a group name' }]}
                >
                    <Input
                        placeholder="Group name"
                        prefix={<Users size={18} strokeWidth={1.5} />}
                        className="rounded-md"
                    />
                </Form.Item>
            </Form>
        </CustomModal>
    )
}

export default CreateGroup